import { Day } from '../model/day.model';
import {createTimestampFromDateAndTime} from "../utils/dateFormatter";
import {productFactory} from "./product.factory";
import {foodFactory} from "./food.factory";
import {planFactory} from "./plan.factory";

export const dayFactory = {

  create: (id, date, comment, plans) => {
    return new Day(id, date, comment, plans);
  },
  createFromDto: (dayDto) => {
    let day  = new Day(dayDto.id, dayDto.date, dayDto.comment, []);

    dayDto.plans.forEach((dayPlan) => {
      let foods = [];

      const planDate = createTimestampFromDateAndTime(day.date, dayPlan.time);

      dayPlan.foods.forEach((foodDto) => {
        let products = [];
        foodDto.products.forEach(productDto => {
          products.push(productFactory.createFromDto(productDto, null));
        });

        let food = foodFactory.createFromDto(foodDto, null);
        food.date = planDate;
        foods.push(food);
      });

      let products = [];
      dayPlan.products.forEach(productDto => {
        products.push(productFactory.createFromDto(productDto, null));
      });
      day.addPlan(planFactory.create(
          dayPlan.id,
          dayPlan.name,
          dayPlan.prescribedEnergy.amount,
          dayPlan.time,
          dayPlan.comment,
          foods,
          products,
          planDate
      ));
    });

    return day;
  },
};
